import { render, staticRenderFns } from "./SubscrptionInfos.vue?vue&type=template&id=10ba0da0&"
import script from "./SubscrptionInfos.vue?vue&type=script&lang=js&"
export * from "./SubscrptionInfos.vue?vue&type=script&lang=js&"
import style0 from "./SubscrptionInfos.vue?vue&type=style&index=0&id=10ba0da0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports